<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-achievement" data-bs-toggle="modal" data-bs-target="#achievement-modal-form">Klik</button>
        <div class="modal" id="achievement-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="form-label">Tingkat<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper form-select-style-1">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <select class="form-select form-select-box-1" v-model="form.grade" required oninvalid="this.setCustomValidity('Pilih Tingkat')" oninput="this.setCustomValidity('')">
                                                    <option value="">Pilih Tingkat</option>
                                                    <option value="international">Internasional</option>
                                                    <option value="national">Nasional</option>
                                                    <option value="province">Provinsi</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="form-label">Relate</label>
                                            <div class="d-block">
                                                <div class="form-group mb-3">
                                                    <label class="d-flex align-items-center">
                                                        <input class="form-check-input m-0" type="radio" name="radio_related" :checked="form.related == 1 ? 'checked':''" value="1" v-model="form.related">
                                                        <div class="d-block ms-2 font-bold text-sm">Relate</div>
                                                    </label>
                                                </div>
                                                <div class="form-group">
                                                    <label class="d-flex align-items-center">
                                                        <input class="form-check-input m-0" type="radio" name="radio_related" :checked="form.related == 0 ? 'checked':''" value="0" v-model="form.related">
                                                        <div class="d-block ms-2 font-bold text-sm">Tidak Relate</div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="form-label">Juara</label>
                                            <div class="d-block">
                                                <div class="form-group mb-3">
                                                    <label class="d-flex align-items-center">
                                                        <input class="form-check-input m-0" type="radio" name="radio_champion" :checked="form.champion == 1 ? 'checked':''" value="1" v-model="form.champion">
                                                        <div class="d-block ms-2 font-bold text-sm">Juara</div>
                                                    </label>
                                                </div>
                                                <div class="form-group">
                                                    <label class="d-flex align-items-center">
                                                        <input class="form-check-input m-0" type="radio" name="radio_champion" :checked="form.champion == 0 ? 'checked':''" value="0" v-model="form.champion">
                                                        <div class="d-block ms-2 font-bold text-sm">Tidak Juara</div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Event<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan nama event" v-model="form.name" required oninvalid="this.setCustomValidity('Masukan nama event')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Score<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" v-model="form.score" required oninvalid="this.setCustomValidity('Masukan score')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-achievement">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'AchievementForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id          : "",
                name        : "",
                related     : 1,
                champion    : 1,
                grade       : "",
                score       : ""
            },
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            related: {
                required
            },
            champion: {
                required
            },
            grade: {
                required
            },
            score: {
                required
            }
        }
    },
    methods: {
        loadForm: function(params="") {
            if(params == '') {
                this.label = 'Tambah';
                this.clearForm();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-achievement').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-achievement').click();
            this.$parent.$children[0].$children[0].getData();
            this.clearForm();
        },
        clearForm: function() {
            for (let key in this.form) {
                this.form[key] = '';

                if(key == 'related') {
                    this.form.related = 1;
                }

                if(key == 'champion') {
                    this.form.champion = 1;
                }
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    formData.append(key, this.form[key]);
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'achievement/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'achievement/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];
                            }
                        }
                    }
                });
            }
        }
    },
}
</script>
